import React, { useEffect, useRef } from "react";
import AspectRatioBox from "./AspectRatioBox";

const DonutChart = React.memo(({ gold, silver, isLoading = false }) => {
  const goldPercent = isLoading ? 0 : gold ? (gold / (gold + silver)) * 100 : 0;
  const silverPercent = isLoading ? 0 : silver ? 100 : 0;

  return (
    <div style={{ zIndex: -1, position: "relative" }}>
      <AspectRatioBox ratio={50} hidden={false}>
        <div
          style={{
            width: "100%",
            height: "200%",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Circle space={1} background="#008288" />
          <AnimateCircle percent={silverPercent} color="#C1C8D5" />
          <AnimateCircle percent={goldPercent} color="#F0C74E" />
          <Circle space={"8%"} background="white" />
        </div>
        <div
          style={{
            width: "100%",
            height: "102%",
            position: "absolute",
            top: "99%",
            background: "white",
          }}
        />
      </AspectRatioBox>
    </div>
  );
});

const Circle = ({ space = 0, children, background = "", style = {} }) => {
  return (
    <div
      style={{
        position: "absolute",
        top: space,
        right: space,
        bottom: space,
        left: space,
        background: background,
        borderRadius: "50%",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

const AnimateCircle = ({ percent = 100, color = "transparent" }) => {
  const element = useRef(null);

  useEffect(() => {
    const percentage = percent / 100;
    const timing = percentage * 1;
    const deg = percentage * 180;
    element.current.style.transition = `transform ${timing}s linear`;
    element.current.style.transform = `rotate(${deg}deg)`;
  }, [percent]);

  return (
    <div
      ref={element}
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: `linear-gradient(transparent 50%, ${color} 50%)`,
        borderRadius: "50%",
      }}
    />
  );
};

export default DonutChart;
